import { spacing } from "@minuthq/meatball-ui-react"

import { EmptyStateWithImage } from "src/components/EmptyState/EmptyStateWithImage"
import { useTranslate } from "src/i18n/useTranslate"

import NoTodoTasksEmptyStateImage from "./images/no-to-do-tasks.svg"

export function NoTodoTasks() {
  const { tPlaceholder } = useTranslate()

  return (
    <EmptyStateWithImage
      Image={NoTodoTasksEmptyStateImage}
      title={tPlaceholder("All tasks are complete!")}
      description={tPlaceholder(
        "Review them in the complete tab, and create more tasks when you're ready."
      )}
      imageSpacing={spacing.M}
      limitImageWidth={false}
    />
  )
}
